import React from 'react'
import { PropTypes } from 'prop-types'
import Column from './Column'
import { FourColumnRow, GridSection } from './Grid.styles'

export default function FourColumnContainer({ title, content, border, center }) {
	return (
		<>
			<GridSection>
				{title && <h2>{title}</h2>}
				<FourColumnRow>
					{content.map((column) => {
						if (column._type === 'resourceReference') {
							return <Column key={column._key} border={border} center={center} {...column.resource} />
						}
						return <Column key={column._key} border={border} center={center} {...column} />
					})}
				</FourColumnRow>
			</GridSection>
		</>
	)
}

FourColumnContainer.propTypes = {
	title: PropTypes.string,
	content: PropTypes.array,
	border: PropTypes.bool,
	center: PropTypes.bool,
}
